/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionUI from '@eternal/Common/SectionUI'; // eternal
import StyleConfig from '@eternal/Common/StyleConfig';
import HomeBanner from '@eternal/Components/Banner/HomeBanner'; // eternal
import SimpleButton from '@eternal/Components/Buttons/SimpleButton';
import ContentArea from '@eternal/Components/Layout/ContentArea';
import Testimonials from '@eternal/Components/Sliders/Testimonials';
import AboutEE from '@eternal/Sections/AboutEE';
import AboutSadhguru from '@eternal/Sections/AboutSadhguru';
import AdBanners from '@eternal/Sections/AdBanners';
import Collaborators from '@eternal/Sections/Collaborators';
import JourneyWithSadhguru from '@eternal/Sections/JourneyWithSadhguru'; // eternal
import ListenNow from '@eternal/Sections/ListenNow';
import MusicIcons from '@eternal/Sections/MusicIcons'; // eternal
import PreOrder from '@eternal/Sections/PreOrder';
import SinglesTitle from '@eternal/Sections/SinglesTitle';
import VideoGallery from '@eternal/Sections/VideoGallery';
import { IsoApiConstants } from '../../../constants';

/**
 * Renders Render Simple Button Component
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render Simple Button Component
 */

const RenderSimpleButton = ({
  sectionContent,
  section,
  region,
  lang,
  pageConfig,
}) => {
  // const SimpleButton = dynamic(() => import('@components/Buttons/SimpleButton'));
  if (
    section.sectionId &&
    section.sectionId === IsoApiConstants.sectionId.healthButtonLoginPopup
  ) {
    return (
      <SimpleButton
        style={sectionContent}
        bType={section.sectionId}
        region={region}
        lang={lang}
        pageName={pageConfig?.pageName}
      />
    );
  } else {
    return (
      <SimpleButton
        style={sectionContent}
        region={region}
        lang={lang}
        pageConfig={pageConfig}
      />
    );
  }
};

const RenderStructuredText = ({ sectionContent, region, lang }) => {
  return (
    <Box className="event-text">
      <ContentArea
        mainContent={sectionContent.body}
        tAlign={sectionContent.style}
        region={region}
        lang={lang}
      />
    </Box>
  );
};

const RenderSections = ({
  section,
  sectionContent,
  region,
  lang,
  pType,
  pageName,
  csrData,
  pageBody,
  pageConfig,
  disableButton,
  FYDdate,
  currentRegion,
}) => {
  if (section.sectionId === 'top-banner') {
    return (
      <HomeBanner
        section={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'singles-title') {
    // const SPTakeBreak = dynamic(() => import('@landing_pages/Sadhanapada/SPTakeBreak'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <SinglesTitle
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
          pType={pType}
          pageName={pageName}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'journey-with-sadhguru') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <JourneyWithSadhguru
          sectionContent={section.sectionContent}
          region={region}
          language={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'music-icons') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <MusicIcons
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'testimonials') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <Testimonials
          testimonialsObj={section.sectionContent[0]}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'collaborators') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <Collaborators
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'video-gallery') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <VideoGallery
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'listen-now') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <ListenNow
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'pre-order') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <PreOrder
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'about-ee') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <AboutEE
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'about-sadhguru') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <AboutSadhguru
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'ad-banners') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <AdBanners
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else {
    return (
      <Box as="div" display="block" placeContent="center">
        <StyleConfig
          id={section?.sectionId}
          key={section.sectionId}
          style={section?.styleConfig}
          section={section}
        >
          {section?.sectionContent?.length > 0
            ? section?.sectionContent?.map((secCon, i) => {
                return (
                  <SectionUI
                    key={i}
                    sectionContent={secCon}
                    section={section}
                    region={region}
                    language={lang}
                    pType={pType}
                    pageName={pageName}
                    csrData={csrData}
                    pageBody={pageBody}
                    FYDdate={FYDdate}
                    pageConfig={pageConfig}
                    disableButton={disableButton}
                  />
                );
              })
            : null}
        </StyleConfig>
      </Box>
    );
  }
};

export { RenderSections, RenderSimpleButton, RenderStructuredText };
